module.exports = __webpack_public_path__ + "img/htkj_18.5be09359.jpg";